import { render } from "./ComparisonTaskGroundTruth.vue?vue&type=template&id=9c62cec4&scoped=true"
import script from "./ComparisonTaskGroundTruth.vue?vue&type=script&lang=js"
export * from "./ComparisonTaskGroundTruth.vue?vue&type=script&lang=js"

import "./ComparisonTaskGroundTruth.vue?vue&type=style&index=0&id=9c62cec4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c62cec4"]])

export default __exports__